import { useQuery } from '@apollo/client';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { useEffect } from 'react';
import useAuthQueryParams from './utils/use-auth-query-params';
import { FollowedPropertyDialogGetFollowedPropertiesDocument } from './graphql/get-followed-properties.query.generated';
var useFollowedProperties = function useFollowedProperties() {
  var _data$followedPropert;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? FollowedPropertyDialogGetFollowedPropertiesDocument : _ref$query;
  var _useAllhomesApi = useAllhomesApi(),
    isIdentityLoading = _useAllhomesApi.isIdentityLoading,
    getLogger = _useAllhomesApi.getLogger;
  var log = getLogger('fe-co-allhomes-followed-properties-dialogs#useFollowedProperties');
  var _useAuthQueryParams = useAuthQueryParams(),
    queryParams = _useAuthQueryParams.queryParams;
  var _useQuery = useQuery(query, queryParams),
    data = _useQuery.data,
    loading = _useQuery.loading;
  var followedProperties = (_data$followedPropert = data === null || data === void 0 ? void 0 : data.followedProperties) !== null && _data$followedPropert !== void 0 ? _data$followedPropert : [];
  useEffect(() => {
    log.info('Status change', {
      data,
      loading
    });
  }, [data, loading, log]);
  var getFollowedProperty = args => {
    var _followedProperties$f;
    if (!followedProperties) {
      return null;
    }
    return (_followedProperties$f = followedProperties.find(followedProperty => 'streetAddressId' in args ? followedProperty.property.address.id === "".concat(args.streetAddressId) : followedProperty.id === "".concat(args.followedPropertyId))) !== null && _followedProperties$f !== void 0 ? _followedProperties$f : null;
  };
  var isFollowedProperty = streetAddressId => Boolean(getFollowedProperty({
    streetAddressId
  }));
  return {
    followedProperties,
    getFollowedProperty,
    isFollowedProperty,
    loading: loading || isIdentityLoading
  };
};
export default useFollowedProperties;